import { buildTurkishMenus } from "./cooking/tr/menuCatalog.js";
import { enhanceRecipes } from "./cooking/recipeEnhancer.js";

// Türk aile yemekleri — uyumlu akşam menüleri ve tarifler
// Her menü: { id, anaYemek, corba, salata }

const LEGACY_MENULER = [
  { id: 1, anaYemek: 'Kuru Fasulye', corba: 'Yayla Çorbası', salata: 'Turşu Tabağı' },
  { id: 2, anaYemek: 'Etli Nohut', corba: 'Yayla Çorbası', salata: 'Çoban Salatası' },
  { id: 3, anaYemek: 'Yeşil Mercimek Yemeği', corba: 'Yayla Çorbası', salata: 'Cacık' },
  { id: 4, anaYemek: 'Barbunya Pilaki', corba: 'Yayla Çorbası', salata: 'Söğüş Tabağı' },
  { id: 5, anaYemek: 'Etli Barbunya', corba: 'Domates Çorbası', salata: 'Çoban Salatası' },
  { id: 6, anaYemek: 'Nohutlu Tavuk Yemeği', corba: 'Domates Çorbası', salata: 'Cacık' },
  { id: 7, anaYemek: 'Kıymalı Mercimek Yemeği', corba: 'Domates Çorbası', salata: 'Söğüş Tabağı' },
  { id: 8, anaYemek: 'Etli Börülce', corba: 'Domates Çorbası', salata: 'Turşu Tabağı' },
  { id: 9, anaYemek: 'Karnıyarık', corba: 'Şehriye Çorbası', salata: 'Yoğurtlu Semizotu' },
  { id: 10, anaYemek: 'İmam Bayıldı', corba: 'Şehriye Çorbası', salata: 'Turşu Tabağı' },
  { id: 11, anaYemek: 'Patlıcan Musakka', corba: 'Şehriye Çorbası', salata: 'Cacık' },
  { id: 12, anaYemek: 'Patates Oturtma', corba: 'Şehriye Çorbası', salata: 'Mevsim Salatası' },
  { id: 13, anaYemek: 'Kabak Dolması', corba: 'Domates Çorbası', salata: 'Haydari' },
  { id: 14, anaYemek: 'Biber Dolması', corba: 'Domates Çorbası', salata: 'Cacık' },
  { id: 15, anaYemek: 'Etli Yaprak Sarma', corba: 'Domates Çorbası', salata: 'Yoğurtlu Semizotu' },
  { id: 16, anaYemek: 'Zeytinyağlı Yaprak Sarma', corba: 'Domates Çorbası', salata: 'Mevsim Salatası' },
  { id: 17, anaYemek: 'Karışık Dolma', corba: 'Mercimek Çorbası', salata: 'Cacık' },
  { id: 18, anaYemek: 'Lahana Sarması', corba: 'Mercimek Çorbası', salata: 'Yoğurtlu Semizotu' },
  { id: 19, anaYemek: 'Kabak Mücver', corba: 'Mercimek Çorbası', salata: 'Yoğurtlu Semizotu' },
  { id: 20, anaYemek: 'Fırında Sebzeli Mücver', corba: 'Mercimek Çorbası', salata: 'Turşu Tabağı' },
  { id: 21, anaYemek: 'Taze Fasulye', corba: 'Ezogelin Çorbası', salata: 'Mevsim Salatası' },
  { id: 22, anaYemek: 'Etli Taze Fasulye', corba: 'Ezogelin Çorbası', salata: 'Yoğurtlu Semizotu' },
  { id: 23, anaYemek: 'Bezelye Yemeği', corba: 'Ezogelin Çorbası', salata: 'Turşu Tabağı' },
  { id: 24, anaYemek: 'Etli Bezelye', corba: 'Ezogelin Çorbası', salata: 'Cacık' },
  { id: 25, anaYemek: 'Patates Yemeği', corba: 'Şehriye Çorbası', salata: 'Yoğurtlu Semizotu' },
  { id: 26, anaYemek: 'Etli Patates Yemeği', corba: 'Şehriye Çorbası', salata: 'Turşu Tabağı' },
  { id: 27, anaYemek: 'Kıymalı Ispanak', corba: 'Şehriye Çorbası', salata: 'Cacık' },
  { id: 28, anaYemek: 'Ispanak Yemeği', corba: 'Şehriye Çorbası', salata: 'Mevsim Salatası' },
  { id: 29, anaYemek: 'Kapuska', corba: 'Tavuk Suyu Çorbası', salata: 'Turşu Tabağı' },
  { id: 30, anaYemek: 'Etli Kapuska', corba: 'Tavuk Suyu Çorbası', salata: 'Cacık' },
  { id: 31, anaYemek: 'Pırasa Yemeği', corba: 'Tavuk Suyu Çorbası', salata: 'Mevsim Salatası' },
  { id: 32, anaYemek: 'Kereviz Yemeği', corba: 'Tavuk Suyu Çorbası', salata: 'Yoğurtlu Semizotu' },
  { id: 33, anaYemek: 'Bamya Yemeği', corba: 'Mercimek Çorbası', salata: 'Cacık' },
  { id: 34, anaYemek: 'Etli Bamya', corba: 'Mercimek Çorbası', salata: 'Mevsim Salatası' },
  { id: 35, anaYemek: 'Karnabahar Yemeği', corba: 'Mercimek Çorbası', salata: 'Yoğurtlu Semizotu' },
  { id: 36, anaYemek: 'Sebzeli Güveç', corba: 'Mercimek Çorbası', salata: 'Turşu Tabağı' },
  { id: 37, anaYemek: 'Türlü', corba: 'Ezogelin Çorbası', salata: 'Mevsim Salatası' },
  { id: 38, anaYemek: 'Fırında Karnabahar', corba: 'Ezogelin Çorbası', salata: 'Yoğurtlu Semizotu' },
  { id: 39, anaYemek: 'Fırında Kabak Graten', corba: 'Ezogelin Çorbası', salata: 'Turşu Tabağı' },
  { id: 40, anaYemek: 'İzmir Köfte', corba: 'Ezogelin Çorbası', salata: 'Piyaz' },
  { id: 41, anaYemek: 'Fırın Köfte Patates', corba: 'Yayla Çorbası', salata: 'Cacık' },
  { id: 42, anaYemek: 'Sulu Köfte', corba: 'Yayla Çorbası', salata: 'Turşu Tabağı' },
  { id: 43, anaYemek: 'Terbiyeli Sulu Köfte', corba: 'Yayla Çorbası', salata: 'Piyaz' },
  { id: 44, anaYemek: 'Kadınbudu Köfte', corba: 'Yayla Çorbası', salata: 'Çoban Salatası' },
  { id: 45, anaYemek: 'Tekirdağ Köftesi', corba: 'Domates Çorbası', salata: 'Turşu Tabağı' },
  { id: 46, anaYemek: 'Köfte Izgara', corba: 'Domates Çorbası', salata: 'Piyaz' },
  { id: 47, anaYemek: 'Hasanpaşa Köfte', corba: 'Domates Çorbası', salata: 'Çoban Salatası' },
  { id: 48, anaYemek: 'Dalyan Köfte', corba: 'Domates Çorbası', salata: 'Cacık' },
  { id: 49, anaYemek: 'Sebzeli Köfte', corba: 'Mercimek Çorbası', salata: 'Piyaz' },
  { id: 50, anaYemek: 'Domates Soslu Köfte', corba: 'Mercimek Çorbası', salata: 'Çoban Salatası' },
  { id: 51, anaYemek: 'Tavuk Sote', corba: 'Mercimek Çorbası', salata: 'Roka Salatası' },
  { id: 52, anaYemek: 'Fırın Tavuk', corba: 'Mercimek Çorbası', salata: 'Havuç Tarator' },
  { id: 53, anaYemek: 'Tavuk Güveç', corba: 'Yayla Çorbası', salata: 'Cacık' },
  { id: 54, anaYemek: 'Tavuk Haşlama', corba: 'Yayla Çorbası', salata: 'Roka Salatası' },
  { id: 55, anaYemek: 'Sebzeli Tavuk Yemeği', corba: 'Yayla Çorbası', salata: 'Havuç Tarator' },
  { id: 56, anaYemek: 'Tavuk Kapama', corba: 'Yayla Çorbası', salata: 'Mevsim Salatası' },
  { id: 57, anaYemek: 'Tavuklu Pilav', corba: 'Domates Çorbası', salata: 'Roka Salatası' },
  { id: 58, anaYemek: 'Tavuk Şiş', corba: 'Domates Çorbası', salata: 'Havuç Tarator' },
  { id: 59, anaYemek: 'Tavuk Kanat Fırın', corba: 'Domates Çorbası', salata: 'Mevsim Salatası' },
  { id: 60, anaYemek: 'Mantarlı Tavuk Sote', corba: 'Domates Çorbası', salata: 'Cacık' },
  { id: 61, anaYemek: 'Köri Soslu Tavuk', corba: 'Sebze Çorbası', salata: 'Havuç Tarator' },
  { id: 62, anaYemek: 'Tavuklu Bezelye', corba: 'Sebze Çorbası', salata: 'Mevsim Salatası' },
  { id: 63, anaYemek: 'Fırında Sebzeli Tavuk', corba: 'Sebze Çorbası', salata: 'Cacık' },
  { id: 64, anaYemek: 'Tavuk Rosto', corba: 'Sebze Çorbası', salata: 'Roka Salatası' },
  { id: 65, anaYemek: 'Tavuklu Makarna', corba: 'Mercimek Çorbası', salata: 'Mevsim Salatası' },
  { id: 66, anaYemek: 'Tas Kebabı', corba: 'Mercimek Çorbası', salata: 'Piyaz' },
  { id: 67, anaYemek: 'Orman Kebabı', corba: 'Mercimek Çorbası', salata: 'Gavurdağı Salatası' },
  { id: 68, anaYemek: 'Et Sote', corba: 'Mercimek Çorbası', salata: 'Turşu Tabağı' },
  { id: 69, anaYemek: 'Saç Kavurma', corba: 'Ezogelin Çorbası', salata: 'Piyaz' },
  { id: 70, anaYemek: 'Etli Güveç', corba: 'Ezogelin Çorbası', salata: 'Gavurdağı Salatası' },
  { id: 71, anaYemek: 'Hünkâr Beğendi', corba: 'Ezogelin Çorbası', salata: 'Turşu Tabağı' },
  { id: 72, anaYemek: 'Ali Nazik', corba: 'Ezogelin Çorbası', salata: 'Çoban Salatası' },
  { id: 73, anaYemek: 'Etli Pilav', corba: 'Yayla Çorbası', salata: 'Gavurdağı Salatası' },
  { id: 74, anaYemek: 'Kuzu Haşlama', corba: 'Yayla Çorbası', salata: 'Turşu Tabağı' },
  { id: 75, anaYemek: 'Dana Haşlama', corba: 'Yayla Çorbası', salata: 'Çoban Salatası' },
  { id: 76, anaYemek: 'Etli Kabak Yemeği', corba: 'Yayla Çorbası', salata: 'Piyaz' },
  { id: 77, anaYemek: 'Kıymalı Pide', corba: 'Tarhana Çorbası', salata: 'Turşu Tabağı' },
  { id: 78, anaYemek: 'Lahmacun', corba: 'Tarhana Çorbası', salata: 'Çoban Salatası' },
  { id: 79, anaYemek: 'Etli Ekmek', corba: 'Tarhana Çorbası', salata: 'Piyaz' },
  { id: 80, anaYemek: 'Kuzu Tandır', corba: 'Tarhana Çorbası', salata: 'Gavurdağı Salatası' },
  { id: 81, anaYemek: 'Fırında Etli Sebze', corba: 'Mercimek Çorbası', salata: 'Çoban Salatası' },
  { id: 82, anaYemek: 'Kıymalı Patates', corba: 'Mercimek Çorbası', salata: 'Piyaz' },
  { id: 83, anaYemek: 'Etli Mantar Sote', corba: 'Mercimek Çorbası', salata: 'Gavurdağı Salatası' },
  { id: 84, anaYemek: 'Çökertme Kebabı', corba: 'Mercimek Çorbası', salata: 'Turşu Tabağı' },
  { id: 85, anaYemek: 'Mantı', corba: 'Domates Çorbası', salata: 'Mevsim Salatası' },
  { id: 86, anaYemek: 'Su Böreği', corba: 'Domates Çorbası', salata: 'Yoğurtlu Havuç' },
  { id: 87, anaYemek: 'Tepsi Böreği', corba: 'Domates Çorbası', salata: 'Söğüş Tabağı' },
  { id: 88, anaYemek: 'Ispanaklı Börek', corba: 'Domates Çorbası', salata: 'Cacık' },
  { id: 89, anaYemek: 'Patatesli Börek', corba: 'Yayla Çorbası', salata: 'Yoğurtlu Havuç' },
  { id: 90, anaYemek: 'Peynirli Gözleme', corba: 'Yayla Çorbası', salata: 'Söğüş Tabağı' },
  { id: 91, anaYemek: 'Patatesli Gözleme', corba: 'Yayla Çorbası', salata: 'Cacık' },
  { id: 92, anaYemek: 'Erişte', corba: 'Yayla Çorbası', salata: 'Mevsim Salatası' },
  { id: 93, anaYemek: 'Sebzeli Makarna', corba: 'Şehriye Çorbası', salata: 'Söğüş Tabağı' },
  { id: 94, anaYemek: 'Fırın Makarna', corba: 'Şehriye Çorbası', salata: 'Cacık' },
  { id: 95, anaYemek: 'Yoğurtlu Makarna', corba: 'Şehriye Çorbası', salata: 'Mevsim Salatası' },
  { id: 96, anaYemek: 'İçli Köfte', corba: 'Şehriye Çorbası', salata: 'Yoğurtlu Havuç' },
  { id: 97, anaYemek: 'Hamsi Tava', corba: 'Mercimek Çorbası', salata: 'Roka Salatası' },
  { id: 98, anaYemek: 'Hamsi Buğulama', corba: 'Mercimek Çorbası', salata: 'Yeşil Salata' },
  { id: 99, anaYemek: 'Palamut Tava', corba: 'Mercimek Çorbası', salata: 'Çoban Salatası' },
  { id: 100, anaYemek: 'Palamut Buğulama', corba: 'Mercimek Çorbası', salata: 'Turplu Roka Salatası' },
  { id: 101, anaYemek: 'Levrek Fırın', corba: 'Sebze Çorbası', salata: 'Yeşil Salata' },
  { id: 102, anaYemek: 'Çipura Izgara', corba: 'Sebze Çorbası', salata: 'Çoban Salatası' },
  { id: 103, anaYemek: 'Alabalık Tava', corba: 'Sebze Çorbası', salata: 'Turplu Roka Salatası' },
  { id: 104, anaYemek: 'Balık Buğulama', corba: 'Sebze Çorbası', salata: 'Roka Salatası' },
  { id: 105, anaYemek: 'Somon Fırın', corba: 'Domates Çorbası', salata: 'Çoban Salatası' },
  { id: 106, anaYemek: 'Uskumru Izgara', corba: 'Domates Çorbası', salata: 'Turplu Roka Salatası' },
  { id: 107, anaYemek: 'Menemen', corba: 'Domates Çorbası', salata: 'Çoban Salatası' },
  { id: 108, anaYemek: 'Çılbır', corba: 'Domates Çorbası', salata: 'Cacık' },
  { id: 109, anaYemek: 'Patatesli Yumurta', corba: 'Şehriye Çorbası', salata: 'Mevsim Salatası' },
  { id: 110, anaYemek: 'Ispanaklı Yumurta', corba: 'Şehriye Çorbası', salata: 'Çoban Salatası' },
  { id: 111, anaYemek: 'Sucuklu Yumurta', corba: 'Şehriye Çorbası', salata: 'Cacık' },
  { id: 112, anaYemek: 'Mercimek Köftesi', corba: 'Tarhana Çorbası', salata: 'Turşu Tabağı' },
  { id: 113, anaYemek: 'Kısır', corba: 'Yayla Çorbası', salata: 'Cacık' },
  { id: 114, anaYemek: 'Zeytinyağlı Taze Fasulye', corba: 'Mercimek Çorbası', salata: 'Mevsim Salatası' },
  { id: 115, anaYemek: 'Zeytinyağlı Pırasa', corba: 'Mercimek Çorbası', salata: 'Söğüş Tabağı' },
  { id: 116, anaYemek: 'Zeytinyağlı Enginar', corba: 'Mercimek Çorbası', salata: 'Haydari' },
  { id: 117, anaYemek: 'Zeytinyağlı Kereviz', corba: 'Ezogelin Çorbası', salata: 'Mevsim Salatası' },
  { id: 118, anaYemek: 'Zeytinyağlı Kabak', corba: 'Ezogelin Çorbası', salata: 'Söğüş Tabağı' },
  { id: 119, anaYemek: 'Zeytinyağlı Bakla', corba: 'Ezogelin Çorbası', salata: 'Haydari' },
  { id: 120, anaYemek: 'Zeytinyağlı Börülce', corba: 'Ezogelin Çorbası', salata: 'Cacık' },
  { id: 121, anaYemek: 'Kuru Fasulye', corba: 'Tarhana Çorbası', salata: 'Cacık' },
  { id: 122, anaYemek: 'Etli Nohut', corba: 'Tarhana Çorbası', salata: 'Söğüş Tabağı' },
  { id: 123, anaYemek: 'Yeşil Mercimek Yemeği', corba: 'Tarhana Çorbası', salata: 'Turşu Tabağı' },
  { id: 124, anaYemek: 'Barbunya Pilaki', corba: 'Tarhana Çorbası', salata: 'Çoban Salatası' },
  { id: 125, anaYemek: 'Etli Barbunya', corba: 'Sebze Çorbası', salata: 'Söğüş Tabağı' },
  { id: 126, anaYemek: 'Nohutlu Tavuk Yemeği', corba: 'Sebze Çorbası', salata: 'Turşu Tabağı' },
  { id: 127, anaYemek: 'Kıymalı Mercimek Yemeği', corba: 'Sebze Çorbası', salata: 'Çoban Salatası' },
  { id: 128, anaYemek: 'Etli Börülce', corba: 'Sebze Çorbası', salata: 'Cacık' },
  { id: 129, anaYemek: 'Karnıyarık', corba: 'Mercimek Çorbası', salata: 'Cacık' },
  { id: 130, anaYemek: 'İmam Bayıldı', corba: 'Mercimek Çorbası', salata: 'Mevsim Salatası' },
  { id: 131, anaYemek: 'Patlıcan Musakka', corba: 'Mercimek Çorbası', salata: 'Yoğurtlu Semizotu' },
  { id: 132, anaYemek: 'Patates Oturtma', corba: 'Mercimek Çorbası', salata: 'Turşu Tabağı' },
  { id: 133, anaYemek: 'Kabak Dolması', corba: 'Yayla Çorbası', salata: 'Yoğurtlu Semizotu' },
  { id: 134, anaYemek: 'Biber Dolması', corba: 'Yayla Çorbası', salata: 'Mevsim Salatası' },
  { id: 135, anaYemek: 'Etli Yaprak Sarma', corba: 'Yayla Çorbası', salata: 'Haydari' },
  { id: 136, anaYemek: 'Zeytinyağlı Yaprak Sarma', corba: 'Yayla Çorbası', salata: 'Cacık' },
  { id: 137, anaYemek: 'Karışık Dolma', corba: 'Tarhana Çorbası', salata: 'Mevsim Salatası' },
  { id: 138, anaYemek: 'Lahana Sarması', corba: 'Tarhana Çorbası', salata: 'Haydari' },
  { id: 139, anaYemek: 'Kabak Mücver', corba: 'Şehriye Çorbası', salata: 'Cacık' },
  { id: 140, anaYemek: 'Fırında Sebzeli Mücver', corba: 'Şehriye Çorbası', salata: 'Mevsim Salatası' },
  { id: 141, anaYemek: 'Taze Fasulye', corba: 'Tavuk Suyu Çorbası', salata: 'Turşu Tabağı' },
  { id: 142, anaYemek: 'Etli Taze Fasulye', corba: 'Tavuk Suyu Çorbası', salata: 'Cacık' },
  { id: 143, anaYemek: 'Bezelye Yemeği', corba: 'Tavuk Suyu Çorbası', salata: 'Mevsim Salatası' },
  { id: 144, anaYemek: 'Etli Bezelye', corba: 'Tavuk Suyu Çorbası', salata: 'Yoğurtlu Semizotu' },
  { id: 145, anaYemek: 'Patates Yemeği', corba: 'Mercimek Çorbası', salata: 'Cacık' },
  { id: 146, anaYemek: 'Etli Patates Yemeği', corba: 'Mercimek Çorbası', salata: 'Mevsim Salatası' },
  { id: 147, anaYemek: 'Kıymalı Ispanak', corba: 'Mercimek Çorbası', salata: 'Yoğurtlu Semizotu' },
  { id: 148, anaYemek: 'Ispanak Yemeği', corba: 'Mercimek Çorbası', salata: 'Turşu Tabağı' },
  { id: 149, anaYemek: 'Kapuska', corba: 'Ezogelin Çorbası', salata: 'Mevsim Salatası' },
  { id: 150, anaYemek: 'Etli Kapuska', corba: 'Ezogelin Çorbası', salata: 'Yoğurtlu Semizotu' },
  { id: 151, anaYemek: 'Pırasa Yemeği', corba: 'Ezogelin Çorbası', salata: 'Turşu Tabağı' },
  { id: 152, anaYemek: 'Kereviz Yemeği', corba: 'Ezogelin Çorbası', salata: 'Cacık' },
  { id: 153, anaYemek: 'Bamya Yemeği', corba: 'Şehriye Çorbası', salata: 'Yoğurtlu Semizotu' },
  { id: 154, anaYemek: 'Etli Bamya', corba: 'Şehriye Çorbası', salata: 'Turşu Tabağı' },
  { id: 155, anaYemek: 'Karnabahar Yemeği', corba: 'Şehriye Çorbası', salata: 'Cacık' },
  { id: 156, anaYemek: 'Sebzeli Güveç', corba: 'Şehriye Çorbası', salata: 'Mevsim Salatası' },
  { id: 157, anaYemek: 'Türlü', corba: 'Tavuk Suyu Çorbası', salata: 'Turşu Tabağı' },
  { id: 158, anaYemek: 'Fırında Karnabahar', corba: 'Tavuk Suyu Çorbası', salata: 'Cacık' },
  { id: 159, anaYemek: 'Fırında Kabak Graten', corba: 'Tavuk Suyu Çorbası', salata: 'Mevsim Salatası' },
  { id: 160, anaYemek: 'İzmir Köfte', corba: 'Domates Çorbası', salata: 'Cacık' },
  { id: 161, anaYemek: 'Fırın Köfte Patates', corba: 'Mercimek Çorbası', salata: 'Piyaz' },
  { id: 162, anaYemek: 'Sulu Köfte', corba: 'Mercimek Çorbası', salata: 'Çoban Salatası' },
  { id: 163, anaYemek: 'Terbiyeli Sulu Köfte', corba: 'Mercimek Çorbası', salata: 'Cacık' },
  { id: 164, anaYemek: 'Kadınbudu Köfte', corba: 'Mercimek Çorbası', salata: 'Turşu Tabağı' },
  { id: 165, anaYemek: 'Tekirdağ Köftesi', corba: 'Ezogelin Çorbası', salata: 'Çoban Salatası' },
  { id: 166, anaYemek: 'Köfte Izgara', corba: 'Ezogelin Çorbası', salata: 'Cacık' },
  { id: 167, anaYemek: 'Hasanpaşa Köfte', corba: 'Ezogelin Çorbası', salata: 'Turşu Tabağı' },
  { id: 168, anaYemek: 'Dalyan Köfte', corba: 'Ezogelin Çorbası', salata: 'Piyaz' },
  { id: 169, anaYemek: 'Sebzeli Köfte', corba: 'Yayla Çorbası', salata: 'Cacık' },
  { id: 170, anaYemek: 'Domates Soslu Köfte', corba: 'Yayla Çorbası', salata: 'Turşu Tabağı' },
  { id: 171, anaYemek: 'Tavuk Sote', corba: 'Domates Çorbası', salata: 'Mevsim Salatası' },
  { id: 172, anaYemek: 'Fırın Tavuk', corba: 'Domates Çorbası', salata: 'Cacık' },
  { id: 173, anaYemek: 'Tavuk Güveç', corba: 'Sebze Çorbası', salata: 'Havuç Tarator' },
  { id: 174, anaYemek: 'Tavuk Haşlama', corba: 'Sebze Çorbası', salata: 'Mevsim Salatası' },
  { id: 175, anaYemek: 'Sebzeli Tavuk Yemeği', corba: 'Sebze Çorbası', salata: 'Cacık' },
  { id: 176, anaYemek: 'Tavuk Kapama', corba: 'Sebze Çorbası', salata: 'Roka Salatası' },
  { id: 177, anaYemek: 'Tavuklu Pilav', corba: 'Mercimek Çorbası', salata: 'Mevsim Salatası' },
  { id: 178, anaYemek: 'Tavuk Şiş', corba: 'Mercimek Çorbası', salata: 'Cacık' },
  { id: 179, anaYemek: 'Tavuk Kanat Fırın', corba: 'Mercimek Çorbası', salata: 'Roka Salatası' },
  { id: 180, anaYemek: 'Mantarlı Tavuk Sote', corba: 'Mercimek Çorbası', salata: 'Havuç Tarator' },
  { id: 181, anaYemek: 'Köri Soslu Tavuk', corba: 'Yayla Çorbası', salata: 'Cacık' },
  { id: 182, anaYemek: 'Tavuklu Bezelye', corba: 'Yayla Çorbası', salata: 'Roka Salatası' },
  { id: 183, anaYemek: 'Fırında Sebzeli Tavuk', corba: 'Yayla Çorbası', salata: 'Havuç Tarator' },
  { id: 184, anaYemek: 'Tavuk Rosto', corba: 'Yayla Çorbası', salata: 'Mevsim Salatası' },
  { id: 185, anaYemek: 'Tavuklu Makarna', corba: 'Domates Çorbası', salata: 'Roka Salatası' },
  { id: 186, anaYemek: 'Tas Kebabı', corba: 'Yayla Çorbası', salata: 'Turşu Tabağı' },
  { id: 187, anaYemek: 'Orman Kebabı', corba: 'Yayla Çorbası', salata: 'Çoban Salatası' },
  { id: 188, anaYemek: 'Et Sote', corba: 'Yayla Çorbası', salata: 'Piyaz' },
  { id: 189, anaYemek: 'Saç Kavurma', corba: 'Tarhana Çorbası', salata: 'Turşu Tabağı' },
  { id: 190, anaYemek: 'Etli Güveç', corba: 'Tarhana Çorbası', salata: 'Çoban Salatası' },
  { id: 191, anaYemek: 'Hünkâr Beğendi', corba: 'Tarhana Çorbası', salata: 'Piyaz' },
  { id: 192, anaYemek: 'Ali Nazik', corba: 'Tarhana Çorbası', salata: 'Gavurdağı Salatası' },
  { id: 193, anaYemek: 'Etli Pilav', corba: 'Mercimek Çorbası', salata: 'Çoban Salatası' },
  { id: 194, anaYemek: 'Kuzu Haşlama', corba: 'Mercimek Çorbası', salata: 'Piyaz' },
  { id: 195, anaYemek: 'Dana Haşlama', corba: 'Mercimek Çorbası', salata: 'Gavurdağı Salatası' },
  { id: 196, anaYemek: 'Etli Kabak Yemeği', corba: 'Mercimek Çorbası', salata: 'Turşu Tabağı' },
  { id: 197, anaYemek: 'Kıymalı Pide', corba: 'Ezogelin Çorbası', salata: 'Piyaz' },
  { id: 198, anaYemek: 'Lahmacun', corba: 'Ezogelin Çorbası', salata: 'Gavurdağı Salatası' },
  { id: 199, anaYemek: 'Etli Ekmek', corba: 'Ezogelin Çorbası', salata: 'Turşu Tabağı' },
  { id: 200, anaYemek: 'Kuzu Tandır', corba: 'Ezogelin Çorbası', salata: 'Çoban Salatası' },
  { id: 201, anaYemek: 'Fırında Etli Sebze', corba: 'Yayla Çorbası', salata: 'Gavurdağı Salatası' },
  { id: 202, anaYemek: 'Kıymalı Patates', corba: 'Yayla Çorbası', salata: 'Turşu Tabağı' },
  { id: 203, anaYemek: 'Etli Mantar Sote', corba: 'Yayla Çorbası', salata: 'Çoban Salatası' },
  { id: 204, anaYemek: 'Çökertme Kebabı', corba: 'Yayla Çorbası', salata: 'Piyaz' },
  { id: 205, anaYemek: 'Mantı', corba: 'Şehriye Çorbası', salata: 'Söğüş Tabağı' },
  { id: 206, anaYemek: 'Su Böreği', corba: 'Şehriye Çorbası', salata: 'Cacık' },
  { id: 207, anaYemek: 'Tepsi Böreği', corba: 'Şehriye Çorbası', salata: 'Mevsim Salatası' },
  { id: 208, anaYemek: 'Ispanaklı Börek', corba: 'Şehriye Çorbası', salata: 'Yoğurtlu Havuç' },
  { id: 209, anaYemek: 'Patatesli Börek', corba: 'Mercimek Çorbası', salata: 'Cacık' },
  { id: 210, anaYemek: 'Peynirli Gözleme', corba: 'Mercimek Çorbası', salata: 'Mevsim Salatası' },
  { id: 211, anaYemek: 'Patatesli Gözleme', corba: 'Mercimek Çorbası', salata: 'Yoğurtlu Havuç' },
  { id: 212, anaYemek: 'Erişte', corba: 'Mercimek Çorbası', salata: 'Söğüş Tabağı' },
  { id: 213, anaYemek: 'Sebzeli Makarna', corba: 'Domates Çorbası', salata: 'Mevsim Salatası' },
  { id: 214, anaYemek: 'Fırın Makarna', corba: 'Domates Çorbası', salata: 'Yoğurtlu Havuç' },
  { id: 215, anaYemek: 'Yoğurtlu Makarna', corba: 'Domates Çorbası', salata: 'Söğüş Tabağı' },
  { id: 216, anaYemek: 'İçli Köfte', corba: 'Domates Çorbası', salata: 'Cacık' },
  { id: 217, anaYemek: 'Hamsi Tava', corba: 'Domates Çorbası', salata: 'Çoban Salatası' },
  { id: 218, anaYemek: 'Hamsi Buğulama', corba: 'Domates Çorbası', salata: 'Turplu Roka Salatası' },
  { id: 219, anaYemek: 'Palamut Tava', corba: 'Domates Çorbası', salata: 'Roka Salatası' },
  { id: 220, anaYemek: 'Palamut Buğulama', corba: 'Domates Çorbası', salata: 'Yeşil Salata' },
  { id: 221, anaYemek: 'Levrek Fırın', corba: 'Tarhana Çorbası', salata: 'Turplu Roka Salatası' },
  { id: 222, anaYemek: 'Çipura Izgara', corba: 'Tarhana Çorbası', salata: 'Roka Salatası' },
  { id: 223, anaYemek: 'Alabalık Tava', corba: 'Tarhana Çorbası', salata: 'Yeşil Salata' },
  { id: 224, anaYemek: 'Balık Buğulama', corba: 'Tarhana Çorbası', salata: 'Çoban Salatası' },
  { id: 225, anaYemek: 'Somon Fırın', corba: 'Mercimek Çorbası', salata: 'Roka Salatası' },
  { id: 226, anaYemek: 'Uskumru Izgara', corba: 'Mercimek Çorbası', salata: 'Yeşil Salata' },
  { id: 227, anaYemek: 'Menemen', corba: 'Mercimek Çorbası', salata: 'Söğüş Tabağı' },
  { id: 228, anaYemek: 'Çılbır', corba: 'Mercimek Çorbası', salata: 'Mevsim Salatası' },
  { id: 229, anaYemek: 'Patatesli Yumurta', corba: 'Yayla Çorbası', salata: 'Cacık' },
  { id: 230, anaYemek: 'Ispanaklı Yumurta', corba: 'Yayla Çorbası', salata: 'Söğüş Tabağı' },
  { id: 231, anaYemek: 'Sucuklu Yumurta', corba: 'Yayla Çorbası', salata: 'Mevsim Salatası' },
  { id: 232, anaYemek: 'Mercimek Köftesi', corba: 'Domates Çorbası', salata: 'Cacık' },
  { id: 233, anaYemek: 'Kısır', corba: 'Sebze Çorbası', salata: 'Turşu Tabağı' },
  { id: 234, anaYemek: 'Zeytinyağlı Taze Fasulye', corba: 'Şehriye Çorbası', salata: 'Haydari' },
  { id: 235, anaYemek: 'Zeytinyağlı Pırasa', corba: 'Şehriye Çorbası', salata: 'Cacık' },
  { id: 236, anaYemek: 'Zeytinyağlı Enginar', corba: 'Şehriye Çorbası', salata: 'Mevsim Salatası' },
  { id: 237, anaYemek: 'Zeytinyağlı Kereviz', corba: 'Domates Çorbası', salata: 'Haydari' },
  { id: 238, anaYemek: 'Zeytinyağlı Kabak', corba: 'Domates Çorbası', salata: 'Cacık' },
  { id: 239, anaYemek: 'Zeytinyağlı Bakla', corba: 'Domates Çorbası', salata: 'Mevsim Salatası' },
  { id: 240, anaYemek: 'Zeytinyağlı Börülce', corba: 'Domates Çorbası', salata: 'Söğüş Tabağı' },
  { id: 241, anaYemek: 'Kuru Fasulye', corba: 'Yayla Çorbası', salata: 'Turşu Tabağı' },
  { id: 242, anaYemek: 'Etli Nohut', corba: 'Yayla Çorbası', salata: 'Çoban Salatası' },
  { id: 243, anaYemek: 'Yeşil Mercimek Yemeği', corba: 'Yayla Çorbası', salata: 'Cacık' },
  { id: 244, anaYemek: 'Barbunya Pilaki', corba: 'Yayla Çorbası', salata: 'Söğüş Tabağı' },
  { id: 245, anaYemek: 'Etli Barbunya', corba: 'Domates Çorbası', salata: 'Çoban Salatası' },
  { id: 246, anaYemek: 'Nohutlu Tavuk Yemeği', corba: 'Domates Çorbası', salata: 'Cacık' },
  { id: 247, anaYemek: 'Kıymalı Mercimek Yemeği', corba: 'Domates Çorbası', salata: 'Söğüş Tabağı' },
  { id: 248, anaYemek: 'Etli Börülce', corba: 'Domates Çorbası', salata: 'Turşu Tabağı' },
  { id: 249, anaYemek: 'Karnıyarık', corba: 'Şehriye Çorbası', salata: 'Yoğurtlu Semizotu' },
  { id: 250, anaYemek: 'İmam Bayıldı', corba: 'Şehriye Çorbası', salata: 'Turşu Tabağı' },
];

export const MENULER = buildTurkishMenus(LEGACY_MENULER);

const OZEL_TARIFLER = {
  "Mercimek Çorbası": {
    "kategori": "Çorba",
    "sure": "35 dk",
    "porsiyon": "4-6 kişilik",
    "malzemeler": [
      "1 su bardağı kırmızı mercimek",
      "1 adet soğan",
      "1 adet havuç",
      "1 yemek kaşığı salça",
      "2 yemek kaşığı sıvı yağ",
      "6 su bardağı su veya et suyu",
      "Tuz, karabiber, kimyon"
    ],
    "yapilis": [
      "Soğanı ve havucu doğrayıp yağda birkaç dakika kavurun.",
      "Salçayı ekleyip kokusu çıkana kadar çevirin.",
      "Yıkanmış mercimeği ve suyu ekleyip mercimekler yumuşayana kadar pişirin.",
      "Blenderdan geçirip tuz ve baharatla kıvamını ayarlayın."
    ]
  },
  "Ezogelin Çorbası": {
    "kategori": "Çorba",
    "sure": "40 dk",
    "porsiyon": "4-6 kişilik",
    "malzemeler": [
      "1 çay bardağı kırmızı mercimek",
      "2 yemek kaşığı pirinç",
      "1 yemek kaşığı bulgur",
      "1 adet soğan",
      "1 yemek kaşığı salça",
      "Tereyağı veya sıvı yağ",
      "Nane, pul biber, tuz"
    ],
    "yapilis": [
      "Soğanı yağda kavurun, salçayı ekleyin.",
      "Mercimek, pirinç ve bulguru yıkayıp tencereye alın.",
      "Suyunu ekleyip bakliyatlar dağılana kadar pişirin.",
      "Nane ve pul biberle lezzetlendirip sıcak servis edin."
    ]
  },
  "Yayla Çorbası": {
    "kategori": "Çorba",
    "sure": "30 dk",
    "porsiyon": "4-6 kişilik",
    "malzemeler": [
      "1 çay bardağı pirinç",
      "1 kase yoğurt",
      "1 yemek kaşığı un",
      "1 yumurta sarısı",
      "6 su bardağı su",
      "Tereyağı, nane, tuz"
    ],
    "yapilis": [
      "Pirinci suyla yumuşayana kadar haşlayın.",
      "Yoğurt, un ve yumurta sarısını çırpıp çorbanın suyuyla ılıştırın.",
      "Terbiyeyi tencereye azar azar ekleyip karıştırarak pişirin.",
      "Üzerine tereyağında yakılmış nane gezdirin."
    ]
  },
  "Tarhana Çorbası": {
    "kategori": "Çorba",
    "sure": "25 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "4 yemek kaşığı tarhana",
      "1 yemek kaşığı salça",
      "1 yemek kaşığı tereyağı",
      "5 su bardağı su",
      "Tuz, nane"
    ],
    "yapilis": [
      "Tarhanayı bir miktar suyla açın.",
      "Tencerede yağ ve salçayı kavurun.",
      "Suyu ve tarhanayı ekleyip sürekli karıştırarak pişirin.",
      "Kıvam alınca tuz ve nane ile servis edin."
    ]
  },
  "Domates Çorbası": {
    "kategori": "Çorba",
    "sure": "25 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "4 adet domates veya domates rendesi",
      "1 yemek kaşığı un",
      "1 yemek kaşığı tereyağı",
      "4 su bardağı su veya süt-su karışımı",
      "Tuz, karabiber",
      "İsteğe göre kaşar"
    ],
    "yapilis": [
      "Unu tereyağında hafifçe kavurun.",
      "Domates rendesini ekleyip birkaç dakika pişirin.",
      "Suyunu ekleyip kaynatın, gerekirse blenderdan geçirin.",
      "Kaşar rendesiyle sıcak servis edin."
    ]
  },
  "Şehriye Çorbası": {
    "kategori": "Çorba",
    "sure": "30-40 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "1-2 su bardağı şehriye için uygun ana malzeme",
      "1 adet soğan",
      "1 yemek kaşığı un veya terbiye malzemesi",
      "5-6 su bardağı su/et suyu",
      "Tuz ve uygun baharatlar"
    ],
    "yapilis": [
      "Şehriye malzemesini temizleyip doğrayın veya hazırlayın.",
      "Soğanı az yağda kavurun, ana malzemeyi ekleyin.",
      "Suyunu verip malzemeler yumuşayana kadar pişirin.",
      "Gerekirse blenderdan geçirip tuz ve baharatla servis edin."
    ]
  },
  "Tavuk Suyu Çorbası": {
    "kategori": "Çorba",
    "sure": "30-40 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "1-2 su bardağı tavuk suyu için uygun ana malzeme",
      "1 adet soğan",
      "1 yemek kaşığı un veya terbiye malzemesi",
      "5-6 su bardağı su/et suyu",
      "Tuz ve uygun baharatlar"
    ],
    "yapilis": [
      "Tavuk Suyu malzemesini temizleyip doğrayın veya hazırlayın.",
      "Soğanı az yağda kavurun, ana malzemeyi ekleyin.",
      "Suyunu verip malzemeler yumuşayana kadar pişirin.",
      "Gerekirse blenderdan geçirip tuz ve baharatla servis edin."
    ]
  },
  "Sebze Çorbası": {
    "kategori": "Çorba",
    "sure": "30-40 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "1-2 su bardağı sebze için uygun ana malzeme",
      "1 adet soğan",
      "1 yemek kaşığı un veya terbiye malzemesi",
      "5-6 su bardağı su/et suyu",
      "Tuz ve uygun baharatlar"
    ],
    "yapilis": [
      "Sebze malzemesini temizleyip doğrayın veya hazırlayın.",
      "Soğanı az yağda kavurun, ana malzemeyi ekleyin.",
      "Suyunu verip malzemeler yumuşayana kadar pişirin.",
      "Gerekirse blenderdan geçirip tuz ve baharatla servis edin."
    ]
  },
  "Düğün Çorbası": {
    "kategori": "Çorba",
    "sure": "30-40 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "1-2 su bardağı düğün için uygun ana malzeme",
      "1 adet soğan",
      "1 yemek kaşığı un veya terbiye malzemesi",
      "5-6 su bardağı su/et suyu",
      "Tuz ve uygun baharatlar"
    ],
    "yapilis": [
      "Düğün malzemesini temizleyip doğrayın veya hazırlayın.",
      "Soğanı az yağda kavurun, ana malzemeyi ekleyin.",
      "Suyunu verip malzemeler yumuşayana kadar pişirin.",
      "Gerekirse blenderdan geçirip tuz ve baharatla servis edin."
    ]
  },
  "Mantar Çorbası": {
    "kategori": "Çorba",
    "sure": "30-40 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "1-2 su bardağı mantar için uygun ana malzeme",
      "1 adet soğan",
      "1 yemek kaşığı un veya terbiye malzemesi",
      "5-6 su bardağı su/et suyu",
      "Tuz ve uygun baharatlar"
    ],
    "yapilis": [
      "Mantar malzemesini temizleyip doğrayın veya hazırlayın.",
      "Soğanı az yağda kavurun, ana malzemeyi ekleyin.",
      "Suyunu verip malzemeler yumuşayana kadar pişirin.",
      "Gerekirse blenderdan geçirip tuz ve baharatla servis edin."
    ]
  },
  "Yoğurt Çorbası": {
    "kategori": "Çorba",
    "sure": "30-40 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "1-2 su bardağı yoğurt için uygun ana malzeme",
      "1 adet soğan",
      "1 yemek kaşığı un veya terbiye malzemesi",
      "5-6 su bardağı su/et suyu",
      "Tuz ve uygun baharatlar"
    ],
    "yapilis": [
      "Yoğurt malzemesini temizleyip doğrayın veya hazırlayın.",
      "Soğanı az yağda kavurun, ana malzemeyi ekleyin.",
      "Suyunu verip malzemeler yumuşayana kadar pişirin.",
      "Gerekirse blenderdan geçirip tuz ve baharatla servis edin."
    ]
  },
  "Arpa Şehriye Çorbası": {
    "kategori": "Çorba",
    "sure": "30-40 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "1-2 su bardağı arpa şehriye için uygun ana malzeme",
      "1 adet soğan",
      "1 yemek kaşığı un veya terbiye malzemesi",
      "5-6 su bardağı su/et suyu",
      "Tuz ve uygun baharatlar"
    ],
    "yapilis": [
      "Arpa Şehriye malzemesini temizleyip doğrayın veya hazırlayın.",
      "Soğanı az yağda kavurun, ana malzemeyi ekleyin.",
      "Suyunu verip malzemeler yumuşayana kadar pişirin.",
      "Gerekirse blenderdan geçirip tuz ve baharatla servis edin."
    ]
  },
  "Tutmaç Çorbası": {
    "kategori": "Çorba",
    "sure": "30-40 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "1-2 su bardağı tutmaç için uygun ana malzeme",
      "1 adet soğan",
      "1 yemek kaşığı un veya terbiye malzemesi",
      "5-6 su bardağı su/et suyu",
      "Tuz ve uygun baharatlar"
    ],
    "yapilis": [
      "Tutmaç malzemesini temizleyip doğrayın veya hazırlayın.",
      "Soğanı az yağda kavurun, ana malzemeyi ekleyin.",
      "Suyunu verip malzemeler yumuşayana kadar pişirin.",
      "Gerekirse blenderdan geçirip tuz ve baharatla servis edin."
    ]
  },
  "Erişteli Yeşil Mercimek Çorbası": {
    "kategori": "Çorba",
    "sure": "30-40 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "1-2 su bardağı erişteli yeşil mercimek için uygun ana malzeme",
      "1 adet soğan",
      "1 yemek kaşığı un veya terbiye malzemesi",
      "5-6 su bardağı su/et suyu",
      "Tuz ve uygun baharatlar"
    ],
    "yapilis": [
      "Erişteli Yeşil Mercimek malzemesini temizleyip doğrayın veya hazırlayın.",
      "Soğanı az yağda kavurun, ana malzemeyi ekleyin.",
      "Suyunu verip malzemeler yumuşayana kadar pişirin.",
      "Gerekirse blenderdan geçirip tuz ve baharatla servis edin."
    ]
  },
  "Kabak Çorbası": {
    "kategori": "Çorba",
    "sure": "30-40 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "1-2 su bardağı kabak için uygun ana malzeme",
      "1 adet soğan",
      "1 yemek kaşığı un veya terbiye malzemesi",
      "5-6 su bardağı su/et suyu",
      "Tuz ve uygun baharatlar"
    ],
    "yapilis": [
      "Kabak malzemesini temizleyip doğrayın veya hazırlayın.",
      "Soğanı az yağda kavurun, ana malzemeyi ekleyin.",
      "Suyunu verip malzemeler yumuşayana kadar pişirin.",
      "Gerekirse blenderdan geçirip tuz ve baharatla servis edin."
    ]
  },
  "Brokoli Çorbası": {
    "kategori": "Çorba",
    "sure": "30-40 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "1-2 su bardağı brokoli için uygun ana malzeme",
      "1 adet soğan",
      "1 yemek kaşığı un veya terbiye malzemesi",
      "5-6 su bardağı su/et suyu",
      "Tuz ve uygun baharatlar"
    ],
    "yapilis": [
      "Brokoli malzemesini temizleyip doğrayın veya hazırlayın.",
      "Soğanı az yağda kavurun, ana malzemeyi ekleyin.",
      "Suyunu verip malzemeler yumuşayana kadar pişirin.",
      "Gerekirse blenderdan geçirip tuz ve baharatla servis edin."
    ]
  },
  "Patates Çorbası": {
    "kategori": "Çorba",
    "sure": "30-40 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "1-2 su bardağı patates için uygun ana malzeme",
      "1 adet soğan",
      "1 yemek kaşığı un veya terbiye malzemesi",
      "5-6 su bardağı su/et suyu",
      "Tuz ve uygun baharatlar"
    ],
    "yapilis": [
      "Patates malzemesini temizleyip doğrayın veya hazırlayın.",
      "Soğanı az yağda kavurun, ana malzemeyi ekleyin.",
      "Suyunu verip malzemeler yumuşayana kadar pişirin.",
      "Gerekirse blenderdan geçirip tuz ve baharatla servis edin."
    ]
  },
  "Kelle Paça Çorbası": {
    "kategori": "Çorba",
    "sure": "30-40 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "1-2 su bardağı kelle paça için uygun ana malzeme",
      "1 adet soğan",
      "1 yemek kaşığı un veya terbiye malzemesi",
      "5-6 su bardağı su/et suyu",
      "Tuz ve uygun baharatlar"
    ],
    "yapilis": [
      "Kelle Paça malzemesini temizleyip doğrayın veya hazırlayın.",
      "Soğanı az yağda kavurun, ana malzemeyi ekleyin.",
      "Suyunu verip malzemeler yumuşayana kadar pişirin.",
      "Gerekirse blenderdan geçirip tuz ve baharatla servis edin."
    ]
  },
  "İşkembe Çorbası": {
    "kategori": "Çorba",
    "sure": "30-40 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "1-2 su bardağı i̇şkembe için uygun ana malzeme",
      "1 adet soğan",
      "1 yemek kaşığı un veya terbiye malzemesi",
      "5-6 su bardağı su/et suyu",
      "Tuz ve uygun baharatlar"
    ],
    "yapilis": [
      "İşkembe malzemesini temizleyip doğrayın veya hazırlayın.",
      "Soğanı az yağda kavurun, ana malzemeyi ekleyin.",
      "Suyunu verip malzemeler yumuşayana kadar pişirin.",
      "Gerekirse blenderdan geçirip tuz ve baharatla servis edin."
    ]
  },
  "Analı Kızlı Çorbası": {
    "kategori": "Çorba",
    "sure": "30-40 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "1-2 su bardağı analı kızlı için uygun ana malzeme",
      "1 adet soğan",
      "1 yemek kaşığı un veya terbiye malzemesi",
      "5-6 su bardağı su/et suyu",
      "Tuz ve uygun baharatlar"
    ],
    "yapilis": [
      "Analı Kızlı malzemesini temizleyip doğrayın veya hazırlayın.",
      "Soğanı az yağda kavurun, ana malzemeyi ekleyin.",
      "Suyunu verip malzemeler yumuşayana kadar pişirin.",
      "Gerekirse blenderdan geçirip tuz ve baharatla servis edin."
    ]
  },
  "Sütlü Domates Çorbası": {
    "kategori": "Çorba",
    "sure": "30-40 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "1-2 su bardağı domates için uygun ana malzeme",
      "1 adet soğan",
      "1 yemek kaşığı un veya terbiye malzemesi",
      "5-6 su bardağı su/et suyu",
      "Tuz ve uygun baharatlar"
    ],
    "yapilis": [
      "Domates malzemesini temizleyip doğrayın veya hazırlayın.",
      "Soğanı az yağda kavurun, ana malzemeyi ekleyin.",
      "Suyunu verip malzemeler yumuşayana kadar pişirin.",
      "Gerekirse blenderdan geçirip tuz ve baharatla servis edin."
    ]
  },
  "Köfteli Çorba": {
    "kategori": "Çorba",
    "sure": "30-40 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "1-2 su bardağı köfteli çorba için uygun ana malzeme",
      "1 adet soğan",
      "1 yemek kaşığı un veya terbiye malzemesi",
      "5-6 su bardağı su/et suyu",
      "Tuz ve uygun baharatlar"
    ],
    "yapilis": [
      "Köfteli Çorba malzemesini temizleyip doğrayın veya hazırlayın.",
      "Soğanı az yağda kavurun, ana malzemeyi ekleyin.",
      "Suyunu verip malzemeler yumuşayana kadar pişirin.",
      "Gerekirse blenderdan geçirip tuz ve baharatla servis edin."
    ]
  },
  "Çoban Salatası": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Çoban için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Mevsim Salatası": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Mevsim için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Cacık": {
    "kategori": "Salata / Meze",
    "sure": "10 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "2 su bardağı yoğurt",
      "1-2 adet salatalık",
      "1 diş sarımsak",
      "Nane, tuz",
      "Az su"
    ],
    "yapilis": [
      "Yoğurdu pürüzsüz çırpın.",
      "Salatalığı küçük doğrayıp yoğurda ekleyin.",
      "Sarımsak, tuz ve naneyi karıştırın.",
      "Kıvamını az suyla açıp soğuk servis edin."
    ]
  },
  "Piyaz": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Piyaz için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Turşu Tabağı": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Turşu için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Gavurdağı Salatası": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Gavurdağı için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Roka Salatası": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Roka için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Yeşil Salata": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Yeşil Salata için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Havuç Tarator": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Havuç Tarator için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Haydari": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Haydari için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Yoğurtlu Semizotu": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Semizotu için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Közlenmiş Biber Salatası": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Biber için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Köz Patlıcan Salatası": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Patlıcan için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Mor Lahana Salatası": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Mor Lahana için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Patates Salatası": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Patates için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Bulgur Salatası": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Bulgur için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Ayran": {
    "kategori": "İçecek",
    "sure": "5 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "2 su bardağı yoğurt",
      "2 su bardağı soğuk su",
      "Tuz"
    ],
    "yapilis": [
      "Yoğurdu derin kapta çırpın.",
      "Soğuk suyu azar azar ekleyin.",
      "Tuzunu ayarlayıp köpürene kadar karıştırın.",
      "Soğuk servis edin."
    ]
  },
  "Söğüş Tabağı": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Söğüş için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Domatesli Soğan Salatası": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Domatesli Soğan için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Yoğurtlu Köz Biber": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Biber için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Yoğurtlu Kabak Salatası": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Kabak için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Naneli Cacık": {
    "kategori": "Salata / Meze",
    "sure": "10 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "2 su bardağı yoğurt",
      "1-2 adet salatalık",
      "1 diş sarımsak",
      "Nane, tuz",
      "Az su"
    ],
    "yapilis": [
      "Yoğurdu pürüzsüz çırpın.",
      "Salatalığı küçük doğrayıp yoğurda ekleyin.",
      "Sarımsak, tuz ve naneyi karıştırın.",
      "Kıvamını az suyla açıp soğuk servis edin."
    ]
  },
  "Marul Salatası": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Marul için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Turplu Roka Salatası": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Turplu Roka için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Yoğurtlu Havuç": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Havuç için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  },
  "Ezme": {
    "kategori": "Salata / Meze",
    "sure": "10-20 dk",
    "porsiyon": "4 kişilik",
    "malzemeler": [
      "Ezme için uygun taze malzemeler",
      "Zeytinyağı",
      "Limon suyu veya yoğurt",
      "Tuz",
      "İsteğe göre nane, maydanoz veya pul biber"
    ],
    "yapilis": [
      "Malzemeleri yıkayıp doğrayın veya közleyip soyun.",
      "Sos için zeytinyağı, limon/yoğurt ve tuzu karıştırın.",
      "Tüm malzemeyi nazikçe harmanlayın.",
      "Servisten önce 5 dakika dinlendirin."
    ]
  }
};


const anaYemekTarifiOlustur = (ad) => {
  const alt = ad.toLocaleLowerCase("tr-TR");

  if (alt.includes("köfte")) {
    return {
      kategori: "Ana Yemek",
      sure: "40-55 dk",
      porsiyon: "4 kişilik",
      malzemeler: ["500 g kıyma", "1 adet soğan", "1 yumurta", "3 yemek kaşığı galeta unu veya bayat ekmek", "Tuz, karabiber, kimyon", "Yanına patates veya sebze"],
      yapilis: ["Kıyma, rendelenmiş soğan, yumurta, ekmek içi ve baharatları yoğurun.", "Harçtan köfteler hazırlayıp en az 10 dakika dinlendirin.", "Tavada, ızgarada veya fırında kontrollü şekilde pişirin.", "Yanında salata, yoğurt veya pilavla sıcak servis edin."],
    };
  }

  if (alt.includes("tavuk")) {
    return {
      kategori: "Ana Yemek",
      sure: "35-50 dk",
      porsiyon: "4 kişilik",
      malzemeler: ["600 g tavuk", "1 adet soğan", "1-2 adet biber", "1 adet domates veya 1 yemek kaşığı salça", "2 yemek kaşığı sıvı yağ", "Tuz, karabiber, kekik"],
      yapilis: ["Tavuğu uygun büyüklükte doğrayın.", "Soğan ve biberi yağda kavurun, tavuğu ekleyip mühürleyin.", "Domates/salça ve baharatları ekleyip kısık ateşte pişirin.", "Tavuk tamamen pişince sıcak servis edin."],
    };
  }

  if (alt.includes("balık") || alt.includes("hamsi") || alt.includes("palamut") || alt.includes("levrek") || alt.includes("çipura") || alt.includes("alabalık") || alt.includes("somon") || alt.includes("uskumru")) {
    return {
      kategori: "Ana Yemek",
      sure: "25-40 dk",
      porsiyon: "4 kişilik",
      malzemeler: ["4 porsiyon temizlenmiş balık", "Zeytinyağı", "Limon", "Tuz", "Karabiber", "İsteğe göre soğan, defne yaprağı ve maydanoz"],
      yapilis: ["Balığı yıkayıp fazla suyunu alın.", "Tuz, karabiber, limon ve az zeytinyağıyla lezzetlendirin.", "Tavada, fırında veya buğulama şeklinde pişirin.", "Roka, yeşillik ve limonla sıcak servis edin."],
    };
  }

  if (alt.includes("dolma") || alt.includes("sarma")) {
    return {
      kategori: "Ana Yemek",
      sure: "60-80 dk",
      porsiyon: "4-6 kişilik",
      malzemeler: ["Dolmalık sebze veya yaprak", "1,5 su bardağı pirinç", "1 adet soğan", "1 yemek kaşığı salça", "Zeytinyağı", "Tuz, karabiber, nane"],
      yapilis: ["İç harç için soğanı, pirinci, salçayı, yağı ve baharatları karıştırın.", "Sebzeleri veya yaprakları harçla çok sıkı olmayacak şekilde doldurun/sarın.", "Tencereye dizip üzerini geçmeyecek kadar sıcak su ekleyin.", "Kısık ateşte pirinçler yumuşayana kadar pişirin."],
    };
  }

  if (alt.includes("fasulye") || alt.includes("nohut") || alt.includes("mercimek") || alt.includes("barbunya") || alt.includes("börülce")) {
    return {
      kategori: "Ana Yemek",
      sure: "45-70 dk",
      porsiyon: "4-6 kişilik",
      malzemeler: ["2 su bardağı haşlanmış bakliyat", "1 adet soğan", "1 yemek kaşığı salça", "2 yemek kaşığı sıvı yağ", "Tuz, karabiber", "İsteğe göre et veya kıyma"],
      yapilis: ["Soğanı yağda kavurun, salçayı ekleyip kokusunu çıkarın.", "Bakliyatı ve varsa eti ekleyip birkaç dakika çevirin.", "Üzerini geçecek kadar sıcak su ekleyin.", "Kısık ateşte lezzetler birleşene kadar pişirin."],
    };
  }

  if (alt.includes("börek") || alt.includes("gözleme") || alt.includes("makarna") || alt.includes("mantı") || alt.includes("erişte") || alt.includes("pide") || alt.includes("lahmacun") || alt.includes("etli ekmek") || alt.includes("içli köfte")) {
    return {
      kategori: "Ana Yemek",
      sure: "35-75 dk",
      porsiyon: "4 kişilik",
      malzemeler: ["Tarife uygun hamur/yufka veya makarna", "İç harç için kıyma, peynir, patates ya da sebze", "Soğan", "Tuz ve baharatlar", "Yoğurt veya sos malzemesi"],
      yapilis: ["İç harcı soğan ve uygun malzemelerle hazırlayın.", "Hamur, yufka veya makarnayı tarife göre düzenleyin.", "Fırında, tavada veya haşlama yöntemiyle pişirin.", "Yanında yoğurt, salata veya çorbayla servis edin."],
    };
  }

  if (alt.includes("zeytinyağlı") || alt.includes("imam bayıldı")) {
    return {
      kategori: "Ana Yemek",
      sure: "35-55 dk",
      porsiyon: "4 kişilik",
      malzemeler: ["1 kg ana sebze", "1 adet soğan", "1 adet havuç veya domates", "Zeytinyağı", "Tuz, az şeker", "Limon suyu"],
      yapilis: ["Sebzeleri temizleyip doğrayın.", "Soğanı zeytinyağında hafif kavurun, sebzeleri ekleyin.", "Az su, tuz ve limonla kısık ateşte pişirin.", "Ilınınca zeytinyağı gezdirip servis edin."],
    };
  }

  if (alt.includes("kebap") || alt.includes("kavurma") || alt.includes("sote") || alt.includes("güveç") || alt.includes("tandır") || alt.includes("haşlama") || alt.includes("beğendi") || alt.includes("ali nazik") || alt.includes("çökertme") || alt.includes("etli") || alt.includes("kuzu") || alt.includes("dana")) {
    return {
      kategori: "Ana Yemek",
      sure: "50-90 dk",
      porsiyon: "4 kişilik",
      malzemeler: ["600 g kuşbaşı et veya kıyma", "1 adet soğan", "1-2 adet biber", "1 adet domates veya salça", "2 yemek kaşığı sıvı yağ", "Tuz, karabiber, kekik"],
      yapilis: ["Eti yüksek ateşte suyunu salıp çekene kadar mühürleyin.", "Soğan ve biberi ekleyip kavurun.", "Domates/salça ve baharatları ilave edin.", "Gerekirse sıcak su ekleyip et yumuşayana kadar pişirin."],
    };
  }

  if (alt.includes("yumurta") || alt.includes("menemen") || alt.includes("çılbır")) {
    return {
      kategori: "Ana Yemek",
      sure: "15-25 dk",
      porsiyon: "2-4 kişilik",
      malzemeler: ["4 adet yumurta", "Domates, biber veya yoğurt", "Tereyağı veya sıvı yağ", "Tuz, karabiber, pul biber"],
      yapilis: ["Sebze kullanılacaksa önce doğrayıp yağda kavurun.", "Yumurtaları ekleyip isteğe göre karıştırarak veya bütün bırakıp pişirin.", "Baharatını ayarlayın.", "Sıcak ekmek ve salatayla servis edin."],
    };
  }

  return {
    kategori: "Ana Yemek",
    sure: "35-60 dk",
    porsiyon: "4 kişilik",
    malzemeler: ["Ana malzeme", "1 adet soğan", "1 yemek kaşığı salça veya domates", "2 yemek kaşığı sıvı yağ", "Tuz ve baharatlar"],
    yapilis: ["Ana malzemeyi temizleyip uygun şekilde doğrayın.", "Soğanı yağda kavurup salça veya domates ekleyin.", "Ana malzemeyi ekleyip kısık ateşte pişirin.", "Tuz ve baharatını ayarlayıp sıcak servis edin."],
  };
};

const tumYemekAdlari = Array.from(new Set(MENULER.flatMap((m) => [m.anaYemek, m.corba, m.salata])));

const HAM_TARIFLER = tumYemekAdlari.reduce((acc, ad) => {
  acc[ad] = OZEL_TARIFLER[ad] || anaYemekTarifiOlustur(ad);
  return acc;
}, {});

export const TARIFLER = enhanceRecipes(HAM_TARIFLER, "tr");
